"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  add: 'Add',
  added: 'Added!',
  buy: 'Buy',
  buyProducts: 'Buy {0} product(s)',
  choose: 'ChooseTest',
  chooseProductsToDiscount: '{0} product(s) - up to {1} off',
  chooseShade: 'Choose shade',
  chooseUpTo0ProductsWith1Discount: 'Choose up to {0} product(s) with {1} discount:',
  chosenShades: 'You chosen shades',
  discountedProduct: 'Discounted product',
  done: 'Done',
  dontMissOut: "Don't miss out!",
  getOffer: 'Get offer',
  itemToYourBasket: '{0} to your basket',
  itemsThatMadeYouEligibleForSpecialOffers: 'Items that made you eligible for Special Offers',
  noShadesChoosen: 'No shades chosen yet',
  outOfStock: 'Out of stock',
  productsGetOffer: '{0} product(s) - Get offer',
  productsInOffer: '{0}/{1} product(s) in offer',
  productsThatMadeYouEligibleForThisOffer: 'Products that made you eligible for this offer',
  productsWithDiscount: '{0} product(s) with discount',
  qty: 'Qty',
  replacement: 'Replacement',
  seeAllItems: 'See all {0}',
  setOfProducts: 'Set of products',
  specialOffer: 'Special Offer',
  total: 'Total',
  youAdded: 'You added',
  yourOffers: 'Your Offers'
};
const translationsNamespace = exports.translationsNamespace = 'checkout-offer-hints';